import { forwardRef } from "react";

import { Box, BoxProps } from "@mui/material";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";
import { mergeSx } from "@/helpers/mergeSx";
import GooglePayButtonContentReverse from "@/icons/illustration/stripe-google-pay-preview-reverse.svg";
import GooglePayButtonContent from "@/icons/illustration/stripe-google-pay-preview.svg";
export const StripeExpressCheckoutGooglePayPreview = forwardRef<HTMLDivElement, BoxProps>(({ sx, ...rest }, ref) => {
  const { backgroundColor, useReverseSvg } = useDynamicThemeAwareVariables(({ mode }) => ({
    backgroundColor: mode === "light" ? "black" : "white",
    useReverseSvg: mode === "dark",
  }));

  return (
    <Box
      ref={ref}
      sx={mergeSx(
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "44px",
          paddingInline: 2,
          backgroundColor,
          borderRadius: 1,
          ["& > svg"]: {
            width: "100%",
            height: "100%",
          },
        },
        sx
      )}
      {...rest}
    >
      {useReverseSvg ? <GooglePayButtonContentReverse /> : <GooglePayButtonContent />}
    </Box>
  );
});

StripeExpressCheckoutGooglePayPreview.displayName = "StripeExpressCheckoutGooglePayPreview";
